/* eslint-disable no-fallthrough */
import React, { useEffect, useRef, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from "react-router";
import { InputGroup, FormControl, Container, Button, Dropdown, Tabs, Form, Col, Row, Table, SplitButton, ButtonGroup, DropdownButton, ToastContainer, Spinner } from 'react-bootstrap';


import { ArticleService } from '../../../services/ArticleService';
import { EditionService } from '../../../services/EditionService';

import DynamicTable from '../../../components/table/dynamic-table/DynamicTable';
import Pagination from '../../../components/pagination/Pagination';
import SideDetails from '../../../components/side-details/SideDetails';
import ClientDetails from '../../../components/side-details/client/client-details/ClientDetails';
import ClientEdition from '../../../components/side-details/client/client-edition/ClientEdition';
import ColManager from '../../../components/table/dynamic-table/col-manager/ColManager';
import Families from '../../../components/families/Families';
import { PreferenceService } from '../../../services/PreferenceService';
import ConfirmDialog from '../../../components/confirm-dialog/ConfirmDialog';
import ErrorManager from "../../../components/error-manager/ErrorManager";
import { GlobalContext } from "../../../services/GlobalProvider";
import { formatTableHeadersFromPrefs, granted, getFile } from '../../../helper/Helper'
import './Styles.scss';


const JsonTpl = (props) => {

    const { globalContextLoaded, preferences, parametres, folderDetails, grants, getPreferences } = React.useContext(GlobalContext);
    const data = props?.data?.data

    function TreeView({
        data,
        toggled = true,
        name = null,
        isLast = true,
        isChildElement = false,
        isParentToggled = true
    }) {
        const [isToggled, setIsToggled] = React.useState(toggled);

        return (
            <div
                style={{ marginLeft: isChildElement ? 16 : 4 + "px" }}
                className={isParentToggled ? "tree-element" : "tree-element collapsed"}
            >
                <span
                    className={isToggled ? "toggler" : "toggler closed"}
                    onClick={() => setIsToggled(!isToggled)}
                >
                    <i className="material-icons i-lg me-2">arrow_right</i>
                </span>
                {name ? <span className="ms-2 fw-bolder">{name}: </span> : <span className="ms-2"></span>}
                {Array.isArray(data) ? `(${Object.keys(data).length}) [` : "{"}
                {!isToggled && "..."}
                {data && Object.keys(data).map((v, i, a) =>
                    typeof data[v] == "object" ? (
                        <TreeView
                            data={data[v]}
                            isLast={i === a.length - 1}
                            name={Array.isArray(data) ? null : v}
                            isChildElement
                            isParentToggled={isParentToggled && isToggled}
                        />
                    ) : (
                        <p
                            style={{ marginLeft: 16 + "px" }}
                            className={isToggled ? "tree-element" : "tree-element collapsed"}
                        >
                            {Array.isArray(data) ? "" : <span className="fw-bolder">{v}: </span>}
                            {data[v]}
                            {i === a.length - 1 ? "" : ","}
                        </p>
                    )
                )}
                {Array.isArray(data) ? "]" : "}"}
                {!isLast ? "," : ""}
            </div>
        );
    }

    return (
        <div id="JsonTpl" className="py-3 font-monospace px-4 border rounded bg-gray-100">
            <TreeView data={data} name="data" />
        </div>
    )
}

export default JsonTpl;